import React from 'react';

/**
 * Vollbreites Bildband mit dem Gruppenfoto der Crew.
 *
 * Aufbau wie beim Hero: Das Bild liegt als echtes <img> im Markup statt als
 * CSS-Hintergrund - nur so funktionieren srcset und WebP mit JPEG-Fallback.
 *
 * Anders als der Hero laedt es aber `lazy`: Das Band steht weit unterhalb des
 * ersten Bildschirms und darf dem Titelbild, das den LCP bestimmt, keine
 * Bandbreite wegnehmen. Die Groessenangaben am <img> halten den Platz frei,
 * damit beim Nachladen nichts springt.
 */
export default function CrewBand() {
  return (
    <section className="mt-crew" id="crew">
      <picture className="mt-crew__media">
        <source
          type="image/webp"
          srcSet="/img/crew-800.webp 800w, /img/crew-1440.webp 1440w"
          sizes="100vw"
        />
        <img
          src="/img/crew-1440.jpg"
          srcSet="/img/crew-800.jpg 800w, /img/crew-1440.jpg 1440w"
          sizes="100vw"
          width="1440"
          height="892"
          alt="Die Minis der Club-Mini-Thrills-Crew nebeneinander aufgereiht im Hof eines Schlosses bei Sonnenuntergang"
          loading="lazy"
          decoding="async"
        />
      </picture>

      <div className="mt-crew__scrim" aria-hidden="true" />

      <div className="mt-container mt-crew__inner">
        <span className="mt-kicker">Die Crew</span>
        <h2 className="mt-crew__title">Wenn alle zusammenkommen</h2>
      </div>
    </section>
  );
}
